import Pusher from "pusher-js";

let pusherInstance = null;

export const getPusherClient = () => {
  if (!pusherInstance) {
    // pusherInstance = new Pusher(process.env.NEXT_PUBLIC_PUSHER_KEY, {
    //   cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    //   forceTLS: true,
    //   enabledTransports: ["ws", "wss"],
    // });
    pusherInstance = new Pusher("9b204bd9729ab2fcefa0", {
      cluster: "ap2",
      forceTLS: true,
      enabledTransports: ["ws", "wss"],
    });
  }

  return pusherInstance;
};
